import React, { useState, useRef } from "react";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import { withTranslation } from "react-i18next";
import Info from "../../../Theming/icons/Info/index";
import Cross from "../../../Theming/icons/Cross/index";
import "./index.css";
const Tooltip = ({
  className,
  teaser,
  title,
  description,
  isSmall,
  t
}) => {
  const [isTooltipOpen, setTooltipOpen] = useState(false);
  const tooltipRef = useRef(null);
  const tooltipBtn = useRef(null);
  let isEventBound = false;
  const handleClose = () => {
    setTooltipOpen(false);
    tooltipBtn.current.focus();
    if (isEventBound) {
      document.removeEventListener("click", closeOnClickOut);
      isEventBound = false;
    }
  };
  const closeOnClickOut = e => {
    if (tooltipRef && !tooltipRef.current.contains(e.target)) {
      setTooltipOpen(false);
      document.removeEventListener("click", closeOnClickOut);
    }
  };
  const handleKeyPress = e => {
    if (e.key === "Escape" && isTooltipOpen) {
      handleClose();
    }
  };
  const toggleClickTooltip = () => {
    if (!isTooltipOpen) {
      isEventBound = true;
      document.addEventListener("click", closeOnClickOut);
    }
    setTooltipOpen(true);
  };
  const onLeavingTooltip = () => {
    if (isTooltipOpen) {
      setTooltipOpen(false);
    }
  };
  if (!title && !description) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, (description || title) && /*#__PURE__*/React.createElement("div", {
    ref: tooltipRef,
    className: "tooltip",
    onKeyDown: handleKeyPress
  }, /*#__PURE__*/React.createElement("button", {
    className: `tooltip__trigger ${className ? className + "__button" : ""}`,
    type: "button",
    "aria-label": teaser || t("OpenTooltip"),
    onClick: toggleClickTooltip,
    ref: tooltipBtn
  }, teaser && /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    className: "tooltip__teaser",
    field: {
      value: teaser
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: `icon-btn tooltip__button ${className ? className + "__button" : ""} ${isSmall ? "tooltip__button--small" : ""}`
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-btn__inner"
  }, /*#__PURE__*/React.createElement(Info, {
    className: "tooltip__icon"
  })))), /*#__PURE__*/React.createElement("div", {
    role: "status"
  }, isTooltipOpen && /*#__PURE__*/React.createElement("div", {
    className: "tooltip__container",
    onBlur: onLeavingTooltip
  }, /*#__PURE__*/React.createElement("p", {
    className: "tooltip__header"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "tooltip__text"
  }, description), /*#__PURE__*/React.createElement("button", {
    className: "icon-btn tooltip__close",
    "aria-label": t("CloseTooltip"),
    type: "button",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-btn__inner"
  }, /*#__PURE__*/React.createElement(Cross, {
    className: "icon-btn__svg"
  })))))));
};
export default withTranslation()(Tooltip);